import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=833e297e&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=833e297e&prod&scoped=true&lang=css"
import style1 from "./Swiper.vue?vue&type=style&index=1&id=833e297e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833e297e",
  null
  
)

export default component.exports